// src/api/client.js
import axios from 'axios';
import { API_CONFIG } from '../config/auth0.config';

const client = axios.create({
  baseURL: API_CONFIG.baseURL,
  timeout: API_CONFIG.timeout,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Store the Auth0 getAccessTokenSilently function
let getAccessTokenSilently = null;

/**
 * Set the Auth0 getAccessTokenSilently function
 * This should be called from Auth0Provider wrapper
 */
export const setAuth0TokenGetter = (tokenGetter) => {
  getAccessTokenSilently = tokenGetter;
};

// Request Interceptor — automatically add Auth0 JWT token
client.interceptors.request.use(
  async (config) => {
    try {
      // Try to get token from Auth0
      if (getAccessTokenSilently) {
        const token = await getAccessTokenSilently();
        if (token && config.headers) {
          config.headers.Authorization = `Bearer ${token}`;
        }
      } else {
        // Fallback to localStorage (for backward compatibility)
        const token = localStorage.getItem('ACCESS_TOKEN');
        if (token && config.headers) {
          config.headers.Authorization = `Bearer ${token}`;
        }
      }
    } catch (error) {
      console.error('Failed to get access token:', error);
      // Continue without token
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response Interceptor — handle errors
client.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    
    if (status === 401) {
      // Unauthorized - redirect to login
      console.error('Unauthorized request (401)', error.config.url);
      
      // OPTIONAL: Clear any stored auth data only if we are sure the session is invalid globally
      // localStorage.removeItem('ACCESS_TOKEN');
      // localStorage.removeItem('farmciti-auth');
      
      // Stop the aggressive redirect loop. 
      // Let the component handle the error or use a more graceful re-auth flow.
      // if (window.location.pathname !== '/') {
      //   window.location.href = '/';
      // }
    } else if (status === 403) {
      // Forbidden - user doesn't have permission
      console.error('Forbidden - insufficient permissions');
    } else if (status === 500) {
      // Server error
      console.error('Server error - please try again later');
    }
    
    return Promise.reject(error);
  }
);

export default client;
